/**
 * Translate a canonical checklist label such as
 *   "checklist.items.engine_oil"  -> "Motorölstand" / "Engine oil level" / "Nivel ulei motor"
 *   "checklist.templates.standard" -> "Standard Inspektion" / "Standard inspection" / ...
 *
 * If the label is not a known i18n key it is returned verbatim, so
 * user-authored custom items keep working untouched.
 */
export function translateChecklistLabel(label, t) {
  if (typeof label !== "string" || !label) return label || "";
  if (label.startsWith("checklist.items.") || label.startsWith("checklist.templates.")) {
    return t(label, { defaultValue: label });
  }
  return label;
}

export const STANDARD_CHECKLIST_KEYS = [
  "engine_oil", "coolant", "brake_fluid",
  "brakes_front", "brakes_rear",
  "tire_front_left", "tire_front_right",
  "tire_rear_left", "tire_rear_right",
  "lights", "wipers", "battery", "diagnostic", "test_drive",
];
